module.exports = __webpack_public_path__ + "img/phone-screen-de.9679986b.png";